import { render, staticRenderFns } from "./CountrySettings.vue?vue&type=template&id=7d8986b2&scoped=true"
import script from "./CountrySettings.vue?vue&type=script&lang=js"
export * from "./CountrySettings.vue?vue&type=script&lang=js"
import style0 from "./CountrySettings.vue?vue&type=style&index=0&id=7d8986b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8986b2",
  null
  
)

export default component.exports